import { CommonSubmissionItemCardProps, SubmissionItemCard } from '@/components/AppStoreItems/AppStoreItemsCard';
import { antGrey } from '@/components/styles/globalStyles';
import { displayInAppPurchaseType } from '@/helpers/displayHelpers';
import { AppStoreReviewSubmissionItemType, InAppPurchase } from '@/types';
import Space from 'antd/lib/space';
import Text from 'antd/lib/typography/Text';
import * as React from 'react';

export interface InAppPurchaseCardProps extends CommonSubmissionItemCardProps {
    inAppPurchase: InAppPurchase;
}

export const InAppPurchaseCard: React.FC<InAppPurchaseCardProps> = ({ inAppPurchase, ...rest }) => {
    return (
        <SubmissionItemCard item={inAppPurchase} type={AppStoreReviewSubmissionItemType.InAppPurchase} {...rest}>
            <Text style={{ fontWeight: 400, color: antGrey.grey9, fontSize: 14 }}>{inAppPurchase.name}</Text>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8,
                    width: '100%',
                }}
            >
                <Space>
                    <Text style={{ fontWeight: 400, color: antGrey.grey7 }}>
                        {displayInAppPurchaseType(inAppPurchase.inAppPurchaseType)}
                    </Text>
                    <Text style={{ fontWeight: 400, color: antGrey.grey7 }} code>
                        {inAppPurchase.productId}
                    </Text>
                </Space>
                {inAppPurchase.reviewNote && (
                    <Text style={{ fontWeight: 400, color: antGrey.grey7 }}>{inAppPurchase.reviewNote}</Text>
                )}
            </div>
        </SubmissionItemCard>
    );
};
